import { render, staticRenderFns } from "./WhatsAppPhoneInput.vue?vue&type=template&id=f85206d8&scoped=true&"
import script from "./WhatsAppPhoneInput.vue?vue&type=script&lang=js&"
export * from "./WhatsAppPhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppPhoneInput.vue?vue&type=style&index=0&id=f85206d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85206d8",
  null
  
)

export default component.exports